import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type CseValidationInput = {
  enrollmentId: number
  token: string
}

export function rejectEnrollmentCse({ enrollmentId, token }: CseValidationInput) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.rejectCse.url, { id: enrollmentId }))
    .post<void, Pick<CseValidationInput, 'token'>>({ token })
}
